import { apiClient } from '@/api/client';

export interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  token?: string;
  accessToken?: string;
  data?: {
    token?: string;
    accessToken?: string;
    user?: unknown;
  };
  user?: unknown;
}

export interface LoginResult {
  token: string;
  user?: unknown;
}

const resolveToken = (response: LoginResponse) =>
  response.token ?? response.accessToken ?? response.data?.token ?? response.data?.accessToken;

const resolveUser = (response: LoginResponse) => response.user ?? response.data?.user;

export async function login(payload: LoginRequest): Promise<LoginResult> {
  const response = await apiClient.post<LoginResponse>('/admin/login', payload);
  const token = resolveToken(response);

  if (!token) {
    throw new Error('Login response did not include an auth token.');
  }

  return {
    token,
    user: resolveUser(response),
  };
}
export async function loginDetails(): Promise<any> {
  const response = await apiClient.get<any>('/admin/token-details');
  console.log(response);
  return response[0];
}